import { Controller } from "@hotwired/stimulus"

// CSP-safe stand-ins for the inline handlers production blocks (script-src
// has no 'unsafe-inline', and attribute handlers can't carry a nonce —
// they silently no-op'd on staging/prod while working in dev, 2026-08-18).
export default class extends Controller {
  static values = { event: String }

  // <button data-action="click->dom-events#fire" data-dom-events-event-value="toolbox-chat:toggle">
  fire() {
    if (this.eventValue) window.dispatchEvent(new CustomEvent(this.eventValue))
  }

  // Row navigation: data-action="click->dom-events#nav" data-nav-url="…"
  nav(e) {
    if (e.target.closest("a, button, input, select, label")) return
    const url = e.currentTarget.dataset.navUrl
    if (url) window.location = url
  }

  // Click-to-select for copyable fields: data-action="click->dom-events#select"
  select(e) {
    e.currentTarget.select?.()
  }
}
